import React from 'react';
import { motion } from 'framer-motion';
export function FinalCtaSection() {
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById('precio');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="py-28 px-6 bg-[radial-gradient(ellipse_at_center,#1a0a00_0%,#0A0A0A_70%)] text-center relative" data-id="element-90">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="max-w-[700px] mx-auto" data-id="element-91">
        <h2 className="text-[clamp(32px,5vw,60px)] font-black mb-6 text-white" data-id="element-92">
          Tu fábrica de contenido
          <br data-id="element-93" />
          empieza <span className="text-orange" data-id="element-94">hoy.</span>
        </h2>

        <p className="text-[18px] text-[#AAAAAA] max-w-[500px] mx-auto mb-12 leading-[1.7]" data-id="element-95">
          Cada día que esperas es un día que tu competencia está publicando,
          creciendo y ganando la confianza de TUS clientes potenciales.
        </p>

        <a href="#precio" onClick={scrollToPricing} className="bg-gradient-to-br from-orange to-[#FF8C00] text-white px-12 py-[18px] rounded-xl font-extrabold text-lg no-underline block transition-all duration-300 shadow-[0_8px_32px_rgba(255,107,0,0.4)] hover:-translate-y-[3px] hover:shadow-[0_12px_40px_rgba(255,107,0,0.6)] max-w-[420px] mx-auto text-center animate-pulse" data-id="element-96">
          🚀 Obtener Acceso Ahora por $9.99 →
        </a>

        <p className="mt-5 text-[14px] text-gray-400" data-id="element-97">
          ✓ Descarga instantánea &nbsp;•&nbsp; Sin suscripción &nbsp;•&nbsp;
          Acceso de por vida
        </p>
      </motion.div>
    </section>;
}